import React from "react";
import { Card } from "antd";
import Title from "antd/es/typography/Title";
import DoughnutChart from "./components/DoughnutChart";
import { useGetRenewalDeclineData } from "../hooks";
import LoaderTsx from "../../../Loader.tsx";
const RenewalDeclineReasons: React.FC = React.memo(() => {
  const { renewalDeclineChartData, isLoading } = useGetRenewalDeclineData();
  return (
    <Card
      style={{
        backgroundColor: "#FFFFFF",
        borderRadius: 8,
        border: "1px solid #E9E9E9",
        boxShadow: "none",
      }}
    >
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <Title
          level={5}
          style={{
            margin: 0,
            color: "#1F5782",
            textTransform: "uppercase",
            fontWeight: 400,
          }}
        >
          <span style={{ fontWeight: 700 }}>RENEWAL</span> <span style={{ fontWeight: 400 }}>DECLINE REASONS</span>
        </Title>
      </div>

      {isLoading ? (
        <LoaderTsx height={"30vh"} />
      ) : (
        <div style={{ display: "flex", float: "left" }}>
          <DoughnutChart data={renewalDeclineChartData} />
        </div>
      )}
    </Card>
  );
});

export default RenewalDeclineReasons;
